/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ArticleSlider/theme';

export const ArticleSliderTheme = theme;
